import type { AdminOrderDestination, OrderDetail, OrderShipment } from '@repo/api-contracts';

/** 관리자가 배송지 주소를 바꿀 수 있는 진행 상태 — 배송 중이어도 송장 없는 배송지는 바꿀 수 있다(SUPER-86 D11). */
const CHANGEABLE_FULFILLMENTS: readonly OrderDetail['fulfillmentStatus'][] = [
  'WAITING',
  'IN_PRODUCTION',
  'SHIPPED',
];
const ADDRESS_LABEL_LENGTH = 20;

/** 주문의 모든 송장(배송지 순서 → 송장 순서) — 중복 송장 검사·마지막 송장 판단에 쓴다. */
export const orderShipmentsOf = (order: Pick<OrderDetail, 'destinations'>): OrderShipment[] =>
  [...order.destinations]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .flatMap((destination) => destination.shipments);

/** 배송지 선택지 이름 — '배송지 {n} · {받는 분} ({기본주소 앞 20자})'. */
export const orderDestinationLabel = (destination: AdminOrderDestination, index: number): string =>
  `배송지 ${index + 1} · ${destination.shippingAddress.recipientName} (${destination.shippingAddress.address1.slice(0, ADDRESS_LABEL_LENGTH)})`;

/** 이 배송지의 주소를 지금 바꿀 수 있는지(D11 관리자) — PAID + WAITING·IN_PRODUCTION·SHIPPED + 그 배송지에 송장 없음. */
export const canChangeDestinationAddress = (
  order: Pick<OrderDetail, 'status' | 'fulfillmentStatus'>,
  destination: Pick<AdminOrderDestination, 'shipments'>,
): boolean =>
  order.status === 'PAID' &&
  CHANGEABLE_FULFILLMENTS.includes(order.fulfillmentStatus) &&
  destination.shipments.length === 0;
